<template>
    <div>
        <GmapMap
            ref="map"
            id="map"
            v-if="user"
            :center="{
                lat: user.location.latitude,
                lng: user.location.longitude,
            }"
            :zoom="13"
            :options="{zoomControl: false,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: true,
                    styles}"
            map-type-id="roadmap"
            class="map"
            @click="info.show = false"
            @zoom_changed="zoom_calc">
            <div v-if="records">
                <div v-if="currMeters.length === 0 && i === 0">
                    <div :key="meter.name" v-for="meter in $route.params.meters">
                        <GmapMarker
                            id="meter.name"
                            v-if="meter.location"
                            :position="{ lat: meter.location.latitude, lng: meter.location.longitude, }"
                            :visible="true"
                            :icon="getIcon(meter.name,meter.issue)"
                            :ref="meter.name"
                            :clickable="true"
                            @click="selectMarker($event, meter.name)"/> 
                    </div>
                </div>
                <div v-else> 
                    <div :key="meter.name" v-for="meter in currMeters">
                        <GmapMarker
                            id="meter.name"
                            v-if="meter.location"
                            :position="{ lat: meter.location.latitude, lng: meter.location.longitude, }"
                            :visible="true"
                            :icon="getIcon(meter.name,meter.issue)"
                            :ref="meter.name"
                            :clickable="true"
                            @click="selectMarker($event, meter.name)"/> 
                    </div>
                </div>
            </div>
        </GmapMap>
        <div class="filterOn">
            <v-btn-toggle>
                <v-btn small color="white" class="grey--text" @click="retrieveMeters('ALL')">Show All Devices</v-btn>
                <v-btn small color="white" class="green--text" @click="retrieveMeters('ON')">On Devices</v-btn>
                <v-btn small color="white" class="black--text" @click="retrieveMeters('OFF')">Off Devices</v-btn>
                <v-btn small color="white" class="red--text" @click="retrieveMeters('OUT')">Offline Devices</v-btn>                
            </v-btn-toggle>
            <p class="mx-2 my-2 font-weight-bold grey--text text--darken-1">"{{$route.params.name}}" Devices Group</p>
         </div>
        <v-bottom-sheet v-model="info.show" inset hide-overlay max-width="450">
            <v-card>
                <v-list>
                    <v-list-item>
                        <v-list-item-content v-if="info.meter" class="ml-6 text-center">
                            <v-list-item-title>
                                <v-btn class="mb-n4" :to="{ name: 'Circuit', params: { id: info.meter.name } }" link text x-large>{{ info.meter.circuit || info.meter.name }}</v-btn>
                                <br>
                                <v-card-text class="mb-n4" style="font-size: 12px" v-if="info.comm != ''">Last comment: {{ info.comm }} on {{ info.commDate }}</v-card-text>
                                <v-card-text class="mb-n4" style="font-size: 12px" v-else>There are no comments posted about his device</v-card-text>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-subtitle v-if="info.record" class="text-center">
                            <v-chip class="ma-2" color="primary" text-color="white" label>
                                {{ info.record.lines.reduce( (suma, l) => suma + l.watts, 0 ).toFixed(2) }}
                                <v-avatar right>W</v-avatar>
                            </v-chip>
                            <v-chip class="ma-2" color="primary" text-color="white" label>
                                {{ info.record.lines.reduce( (suma, l) => suma + l.amps, 0 ).toFixed(2) }}
                                <v-avatar right>A</v-avatar>
                            </v-chip>
                            <v-chip class="ma-2" color="primary" text-color="white" label>
                                {{ (Object.entries(info.record.lines.reduce( (acc, l) => 
                                    l.volts > 10 
                                        ? acc = { suma: acc.suma + l.volts, lines: acc.lines + 1} : acc , 
                                        { suma: 0, lines: 0} )
                                    ).reduce( (total, el) => {
                                        if(el[0] == 'suma') return total + el[1];
                                        else if(total == 0) return 0;
                                        else return total / el[1]
                                    }, 0)).toFixed(2) 
                                }}
                                <v-avatar right>V</v-avatar>
                            </v-chip>
                        </v-list-item-subtitle>
                    </v-list-item>
                </v-list>
                <div class="text-center mb-3">
                    <v-btn text small color="danger" @click="reportIssue(info.meter.name, info.meter.issue)">Report Issue</v-btn>
                    <v-btn text small color="accent" @click="solveIssue(info.meter.name, info.meter.issue)">Mark as solved</v-btn>
                    <br>
                    <v-btn text small color="grey" class="mt-1" @click="shareLocation(info.meter.name)">Share Location</v-btn>
                </div>
                <div class="text-center" v-if="info.record" style="font-size: 12px">Last read: {{info.date}}</div>
            </v-card>
        </v-bottom-sheet>
        <a href="https://mapicons.mapsmarker.com/" class="license">
            <img src="@/assets/map/license.gif" alt="license"  />
        </a>
        <v-snackbar v-model="snackbar">
            Location copied to clipboard
            <template v-slot:action="{ attrs }">
                <v-btn color="pink" text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { default as mapStyle } from '../plugins/mapStyle.json'
import * as VueGoogleMaps from 'vue2-google-maps'
import moment from 'moment'
export default {
    name: 'MapView',
    computed: {
        google: VueGoogleMaps.gmapApi,
        ...mapState({
            user: (state) => state.user.profile,
            meters: (state) => state.meters.meters.map((m) => ({ name: m.name, circuit: m.circuit, location: m.location, issue: m.issue, capacity: m.capacity })),
            records: (state) => state.meters.lastReadings,
            comments: (state) => state.meters.comments,
            allComments: (state) => state.meters.allComments,
            arrayON: (state) => state.meters.arrayON.map((m) => ({ name: m.name, circuit: m.circuit, location: m.location, issue: m.issue, capacity: m.capacity })),
            arrayUP: (state) => state.meters.arrayUP.map((m) => ({ name: m.name, circuit: m.circuit, location: m.location, issue: m.issue, capacity: m.capacity })),
            arrayDOWN: (state) => state.meters.arrayDOWN.map((m) => ({ name: m.name, circuit: m.circuit, location: m.location, issue: m.issue, capacity: m.capacity })),
            arrayOFF: (state) => state.meters.arrayOFF.map((m) => ({ name: m.name, circuit: m.circuit, location: m.location, issue: m.issue, capacity: m.capacity })),
            arrayOUT: (state) => state.meters.arrayOUT.map((m) => ({ name: m.name, circuit: m.circuit, location: m.location, issue: m.issue, capacity: m.capacity })),
            arrayMeterLinks: state => state.meters.arrayMeterLinks,
        }),
        mapCustom(){
            return mapStyle
        },
        styles(){
            return this.mapCustom
        }
    },
    data() {
        return {
            info: { show: false, issue: false, date: '', comm: '', commDate: '' },
            size: 0,
            issue: false,
            solved: false,
            mapLoaded: false,
            metersVisible: false,
            gMapLink: '',
            snackbar: false,
            currMeters: [],
            i: 0,
            location: { latitude: null, longitude: null, zoom: null },
        }
    },
    methods: {
        ...mapActions({ 
            checkIssue: 'meters/checkIssue', 
            uncheckIssue: 'meters/uncheckIssue',
            filteredMeters: 'meters/filteredMeters',
            getComments: 'meters/getComments'
        }),
        selectMarker(e, meter) {
            this.info.show = false
            this.$refs.map.panTo({ lat: e.latLng.lat(), lng: e.latLng.lng(), })
            this.info.meter = this.meters.find((m) => m.name == meter)
            this.info.record = this.records.find((m) => m ? m.meter == meter : false)
            this.info.show = true
            let day = new Date(this.info.record.timestamp).getDate()
            let m = new Date(this.info.record.timestamp).getMonth()
            let months = ['January','February','March','April','May','June','July','August','September','October','November','December']
            let hour = moment(new Date(this.info.record.timestamp).toLocaleTimeString(), "HH:mm:ss").format("HH:mm")
            this.info.date = months[m] + ' ' + String(day) + ' ' + hour
            let comm = this.allComments.find(m => m.name === meter)
            if(comm.comments.length > 0){
                this.info.comm = comm.comments[0].content
                let m_comm = Number((comm.comments[0].date).substr(0,2)) - 1
                let d_comm = Number((comm.comments[0].date).substr(3,2))
                this.info.commDate = months[m_comm] + ' ' + d_comm
            }
            else this.info.comm = ''
        },
        zoom_calc(){
            let zoomArr = [4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22]
            let sizeArr = [4,4,4,6,6,6,6,6,10,20,20,20,30,30,30,40,40,40,40]
            if (!this.$refs.map){
                let sizeIndex = 13
                this.size = sizeArr[sizeIndex]
                return
            }
            this.$refs.map.$mapPromise.then((map) => {
                let zoom = map.getZoom()                    
                let sizeIndex = zoomArr.findIndex(s => s == zoom)
                this.size = sizeArr[sizeIndex]
            })
        },
        getIcon(meter,issue) {
            let record = this.records.find((m) => m ? m.meter == meter : false)
            let m = this.meters.find((n) => n ? n.name == meter : false)
            let limOff = Number(m.capacity)
            let limUp = Number(limOff + (limOff * 0.1))
            let limDown = Number(limOff - (limOff * 0.1))
            let limReg = Number(limOff - (limOff * 0.95))
            if(issue === true){
                return { url: require('@/assets/map/icon-purple.png'), scaledSize: {width: this.size, height: this.size, f: 'px', b: 'px'}, }
            } else {
                if (record) {
                    let time = new Date().getTime() - new Date(record.timestamp).getTime()
                    if ( this.user.minutesToDanger * 60 * 1000 < time ) {
                        return { url: require('@/assets/map/icon-red.png'), scaledSize: {width: this.size, height: this.size, f: 'px', b: 'px'}, }
                    }
                    let watts = record.lines.reduce((total, line) => total + line.watts, 0)
                    if ( watts >= limReg && watts < limDown ) {
                        return { url: require('@/assets/map/icon-yellow.png'), scaledSize: {width: this.size, height: this.size, f: 'px', b: 'px'}, }
                    } else if ( watts >= limDown && watts < limUp ) {
                        return { url: require('@/assets/map/icon-green.png'), scaledSize: {width: this.size, height: this.size, f: 'px', b: 'px'}, }
                    } else if ( watts >= limUp ) {
                        return { url: require('@/assets/map/icon-orange.png'), scaledSize: {width: this.size, height: this.size, f: 'px', b: 'px'},}
                    }              
                    return { url: require('@/assets/map/icon-dark.png'), scaledSize: {width: this.size, height: this.size, f: 'px', b: 'px'}, }
                }
                return { url: require('@/assets/map/icon-dark.png'), scaledSize: {width: this.size, height: this.size, f: 'px', b: 'px'}, }
            }        
        },
        getIconDanger(meter){
            let issue = this.issue
            if(issue) {
                console.log("I'm callin' U", meter)
                return { url: require('@/assets/map/icon-purple.png'), scaledSize: {width: this.size, height: this.size, f: 'px', b: 'px'}, }
            }
        },
        async reportIssue(meter, prob) {
            this.issue = true
            this.info.meter.issue = this.issue
            let meter_id = meter
            let issue = this.issue
            await this.checkIssue({meter_id, issue})
            this.info.show = false
        },
        async solveIssue(meter, prob){
            this.issue = false
            this.info.meter.issue = this.issue
            let meter_id = meter
            let issue = this.issue
            await this.checkIssue({meter_id, issue})
            this.info.show = false
        },
        setMap(){
            this.map = this.$refs.map.$mapObject;
            this.$refs.map.$mapCreated.then(() => {
                this.mapLoaded=true
            })
        },
        async shareLocation(meter){
            let m = this.meters.find((n) => n ? n.name == meter : false)
            let l = this.arrayMeterLinks.find((i) => i ? i.name == m.circuit : false)
            this.gMapLink = l.url
            let copyText = this.gMapLink
            navigator.clipboard.writeText(copyText)
            this.snackbar = true
        },
        async retrieveMeters(status){
            let mts = []
            let orig = this.$route.params.meters
            switch (status) {
                case 'ON':
                    this.i = 1
                    for (let index = 0; index < orig.length; index++) {
                        const element = this.arrayON.find(m => m.name === orig[index].circuit)
                        if(element != undefined) mts.push(element)
                    }
                    this.currMeters = mts
                    break;
                case 'OFF':
                    this.i = 4
                    for (let index = 0; index < orig.length; index++) {
                        const element = this.arrayOFF.find(m => m.name === orig[index].circuit)
                        if(element != undefined) mts.push(element)
                    }
                    this.currMeters = mts
                    break;
                case 'OUT':
                    this.i = 5
                    for (let index = 0; index < orig.length; index++) {
                        const element = this.arrayOUT.find(m => m.name === orig[index].circuit)
                        if(element != undefined) mts.push(element)
                    }
                    this.currMeters = mts
                    break;
                default:
                    this.i = 0
                    this.currMeters = []
                    break;
            }
        },
    },
    mounted(){
        this.zoom_calc()
    },
    watch:{
        records(){
            if(this.info.show) this.info.show = false
            this.$forceUpdate()
        },
    },
}
</script>

<style scoped>
.map {
    display: contents;
}
.license {
    position: absolute;
    z-index: 100;
    bottom: 10px;
    right: 8px;
}
.filterOn {
    position: absolute;
    z-index: 100;
    top: 10px;
    left: 8px;
}
.card {
    position: absolute;
    z-index: 100;
    top: 100px;
    left: 8px;
    height: 100px;
    width: 400px;
}
</style>
